import { render, staticRenderFns } from "./ManageTeamRoles.vue?vue&type=template&id=51b8feb2&scoped=true&"
import script from "./ManageTeamRoles.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ManageTeamRoles.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ManageTeamRoles.vue?vue&type=style&index=0&id=51b8feb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8feb2",
  null
  
)

export default component.exports